export const SHOPIFY_APP_STORE_URL = "https://apps.shopify.com/shakatah";
export const SHOPIFY_APP_HANDLE =
  ((import.meta.env.VITE_SHOPIFY_APP_HANDLE as string | undefined)?.trim() || "shakatah");
export const SHOPIFY_THEME_APP_EMBED_HANDLE = "shakatah-app-embed";
const SHOPIFY_API_KEY = ((import.meta.env.VITE_SHOPIFY_API_KEY as string | undefined)?.trim() || "");

export function buildShopifyThemeEditorAppEmbedUrl(shopDomain?: string | null): string | null {
  const normalizedShop = String(shopDomain || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "");

  if (!normalizedShop || !SHOPIFY_API_KEY) {
    return null;
  }

  const params = new URLSearchParams({
    context: "apps",
    template: "index",
    activateAppId: `${SHOPIFY_API_KEY}/${SHOPIFY_THEME_APP_EMBED_HANDLE}`,
  });

  return `https://${normalizedShop}/admin/themes/current/editor?${params.toString()}`;
}

export function buildShopifyManagedPricingUrl(shopDomain?: string | null): string {
  const normalizedShop = String(shopDomain || "").trim().toLowerCase();
  const storeHandle = normalizedShop.replace(/\.myshopify\.com$/, "");

  if (!storeHandle) {
    return SHOPIFY_APP_STORE_URL;
  }

  return `https://admin.shopify.com/store/${encodeURIComponent(storeHandle)}/charges/${encodeURIComponent(
    SHOPIFY_APP_HANDLE,
  )}/pricing_plans`;
}
